"use strict";

module.exports = {
  template: require('./emil-footer.component.html')
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/footer/emil-footer.component.js